module.exports = __webpack_public_path__ + "img/peiicon3.fbc71c7c.svg";